// src/components/list/NewsTile.tsx

import { AnnouncementTwoTone } from '@mui/icons-material'
import {
  Avatar,
  Divider,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Tooltip,
  useTheme,
} from '@mui/material'
import { useNavigate } from 'react-router-dom'

import { ContractPool } from '@/types/domain/contract'
import { FolderPool } from '@/types/domain/folder'

import { DDMMYYYYHHMM, userLocales } from '../../api'
import { useContractPool, useFolderPool } from '../../hooks'

type Props = {
  news: any
}

export const NewsTile = ({ news }: Props) => {
  const theme = useTheme()
  const success = theme.palette.success.main
  const warning = theme.palette.warning.main

  const fPool: FolderPool = useFolderPool()
  const cPool: ContractPool = useContractPool()

  const navigate = useNavigate()

  const { author, contract_id, folder_id, headline, label, start_time, title } =
    news.attributes

  const fData = fPool.find(f => Number(f.id) === folder_id)
  const cData = cPool.find(f => Number(f.id) === contract_id)

  let name = ''

  if (cData) name += cData.attributes.name
  else if (fData) name += fData.attributes.name
  else name = `(ID existiert nicht)`

  const RELEASED_AT = start_time
    ? new Date(start_time).toLocaleString(userLocales, DDMMYYYYHHMM)
    : 'unveröffentlicht'

  return (
    <ListItemButton onClick={() => navigate(`/news/${news.id}/edit`)}>
      <ListItemAvatar>
        <Tooltip title={`News ID: ${news.id}`}>
          <Avatar sx={{ bgcolor: !start_time ? warning : success }}>
            <AnnouncementTwoTone />
          </Avatar>
        </Tooltip>
      </ListItemAvatar>

      <ListItemText
        primary={title}
        secondary={headline}
        sx={{ width: '45%' }}
      />

      <Divider flexItem orientation={'vertical'} />

      <ListItemText
        primary={
          folder_id ? 'Gebäude' : contract_id ? 'Vertrag' : 'unspezifiziert'
        }
        secondary={name}
        sx={{ pl: 1, width: '15%' }}
      />

      <Divider flexItem orientation={'vertical'} />

      <ListItemText
        primary={'Rubrik'}
        secondary={label || 'unspezifiziert'}
        sx={{ pl: 1, width: '15%' }}
      />

      <Divider flexItem orientation={'vertical'} />

      <ListItemText
        primary={`released: ${RELEASED_AT}`}
        secondary={author && `Autor: ${author}`}
        sx={{ pl: 1, width: '25%' }}
      />
    </ListItemButton>
  )
}
